import React from "react";

class WelcomeLayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      logo: this.props.logo
    }
  }

  render() {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div style={{
              background: this.props.background,
              padding: '1.5rem',
              width: '100%',
              marginBottom: '2rem',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              borderRadius: '12px'
            }}>
              <div className="row align-items-center">
                <div className="col-md-3 text-center">
                  <img 
                    alt="ciber" 
                    style={{
                      maxWidth: "120px",
                      height: "auto"
                    }}
                    src={this.props.logo} 
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src="https://webpage.cibercolegios.com/images/logos/logo.png";
                    }}
                  />
                </div>
                <div className="col-md-9">
                  <h1 className="text-white institution-font mb-2" style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center' }}>
                    Inscripción a {this.props.institutionName || 'Institución'}
                  </h1>
                  {this.props.message ?
                    <h6 className="text-white text-justify institution-font" style={{ fontSize: '1rem' }}>
                      {this.props.message} {this.props.mail}
                    </h6>
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WelcomeLayer;
